import { lazy } from 'react'

export const Digital = lazy(
  () => import(/* webpackChunkName: "soc" */ './Digital')
)

export const DigitalIntelligenceDashboard = lazy(
  () =>
    import(/* webpackChunkName: "soc" */ './Dashboard/DashboardIntelligence')
)

export const DigitalPredictionDashboard = lazy(
  () => import(/* webpackChunkName: "soc" */ './Dashboard/DashboardPrediction')
)

export const Multi = lazy(
  () => import(/* webpackChunkName: "soc" */ './Dashboard/Multi/Multi')
)

export const Descriptive = lazy(
  () => import(/* webpackChunkName: "soc" */ './Dashboard/Prediction/Descriptive/Descriptive')
)

export const Risks = lazy(
  () => import(/* webpackChunkName: "soc" */ './Dashboard/Prediction/Risks/Risks')
)
